'use client';

import dynamic from 'next/dynamic';
import { useEffect, useMemo, useState } from 'react';

const IconsCache = {};

function NoIcon({ name }) {
  if (process.env.NODE_ENV !== 'development') return null;
  return `[noicon-${name}]`;
}

function loadIcon(name) {
  if (!IconsCache[name]) {
    IconsCache[name] = dynamic(
      () => import(`../icons/${name}.js`)
          .then((mod) => mod.default)
          .catch(() => NoIcon),
      {
        ssr: false,
        loading: () => <span style={{ display: 'inline-block', width: 16, height: 16 }} />,
      },
    );
  }
  return IconsCache[name];
}

export default function DynamicIcon({ name, ...props }) {
  const IconComponent = useMemo(() => loadIcon(name), [name]);
  // WEA-169 — ssr:false rend le placeholder <span 16px> côté serveur, mais au 1er rendu
  // client un chunk d'icône DÉJÀ chargé rend directement le <svg> : mismatch d'hydratation
  // sur chaque icône (24 cartes de la search = React jetait toute la colonne et la
  // re-rendait côté client, ~20 s de Render Delay sur le LCP). On rend donc le MÊME
  // placeholder que le serveur jusqu'au mount, puis la vraie icône.
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);
  if (!mounted) return <span style={{ display: 'inline-block', width: 16, height: 16 }} />;
  return <IconComponent name={name} {...props} />;
}

/*

XXX <= /* webpackChunkName: 'icons'

import dynamic from 'next/dynamic';

const Icons = {};

const generateComponentLoaded = (IconComponent) => function IconComponentWrapper(props) {
    return <IconComponent {...props} />;
  };

function NoIcon({ name }) {
  if (process.env.NODE_ENV !== 'development') return null;
  return `[noicon-${name}]`;
}

function loadIcon(name) {
  if (!Icons[name]) {
    Icons[name] = dynamic(
() => import(XXX `../icons/${name}.js`)
        .then((module) => {
          const NewIconComponent = module.default;
          return generateComponentLoaded(NewIconComponent);
        })
        .catch(() => NoIcon),
      {
        ssr: false,
        loading: () => <span />,
      },
    );
  }
  return Icons[name];
}

function DynamicIcon({ name, ...props }) {
  if (true) return name;
  const IconComponent = loadIcon(name);
  return <IconComponent name={name} {...props} />;
}

export default DynamicIcon;

*/
